/* import __COLOCATED_TEMPLATE__ from './modal-form.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */
import IntercomTimezoneOptions from 'embercom/lib/intercom-timezone-options';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

export default class ModalForm extends Component {
  @service intl;
  @service appService;
  @service intercomEventService;

  constructor() {
    super(...arguments);
    this.intl.maybeLoadMessengerTranslations();
  }

  get app() {
    return this.appService.app;
  }

  get canUseHolidayOfficeHours() {
    return this.app?.canUseFeature('holiday-office-hours') ?? false;
  }

  get modalTitle() {
    if (this.args.isEditingSchedule) {
      return this.intl.t('components.settings.office-hours.modal.title.edit-office-hours', {
        isDefault: false,
      });
    } else {
      return this.intl.t('components.settings.office-hours.modal.title.new-office-hours');
    }
  }

  get schedule() {
    return this.args.schedule;
  }

  get settings() {
    return this.args.settings;
  }

  get timeZoneOptions() {
    let currentDate = new Date();

    let timeZones = IntercomTimezoneOptions.map((item) => {
      try {
        let formatter = new Intl.DateTimeFormat(this.intl.primaryLocale, {
          timeZone: item.value,
          timeZoneName: 'longOffset',
        });

        let parts = formatter.formatToParts(currentDate);
        let part = parts.find((p) => p.type === 'timeZoneName');

        return {
          value: item.value,
          text: `(${part.value}) ${item.name}`,
        };
      } catch (_e) {
        return {
          value: item.value,
          text: item.description,
        };
      }
    });

    if (this.schedule.timeZoneName) {
      let scheduleTimeZoneInList = timeZones.find(
        ({ value }) => value === this.schedule.timeZoneName,
      );

      if (!scheduleTimeZoneInList) {
        return [
          ...timeZones,
          {
            value: this.schedule.timeZoneName,
            text: this.schedule.timeZoneName,
          },
        ];
      }
    }

    return timeZones.uniqBy('value');
  }
}
